import { useState } from 'react';

/**
 * ログイン情報登録エラーの状態管理用カスタムフック
 */
export const useStateRegistrationError = () => {
	const [isRegistrationError, setIsRegistrationError] = useState(false); // ログイン情報登録エラーの状態管理

	//  ログイン情報登録エラーのアラートを閉じる際の処理
	const onCloseRegistrationErrorAlert = () => {
		setIsRegistrationError(false);
	};

	return {
		isRegistrationError,
		setIsRegistrationError,
		onCloseRegistrationErrorAlert,
	};
};
